import { render, staticRenderFns } from "./aegon-form.vue?vue&type=template&id=50836592&scoped=true&"
import script from "./aegon-form.vue?vue&type=script&lang=js&"
export * from "./aegon-form.vue?vue&type=script&lang=js&"
import style0 from "./aegon-form.vue?vue&type=style&index=0&id=50836592&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50836592",
  null
  
)

export default component.exports